import { render, staticRenderFns } from "./CustomBreadcrumbs.vue?vue&type=template&id=8789255a"
import script from "./CustomBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./CustomBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports